import constant from '@/common/resources/constant'
import cookie from '@/common/utils/cookie'
import fp from 'lodash/fp'
import _ from 'lodash'
import {
  getAdultCertificationStatus,
  getUserProfile,
  postLogin,
  postLogout,
  postPooqzoneLogin
} from '@/common/utils/request'
import { setUserID, setCookieAdultSetting } from '@/common/utils/common'
import { SERVICE_LOCATION_KEY } from '@/common/resources/const'
import store from '@/store'
import AdbrixUtils from '@/common/utils/adbrix.utils'

const alertFromServer = message => {
  if (!_.isNil(message) && message !== '') {
    alert(message.replace('\\\\n', '\n').replace('\\n', '\n'))
  }
}
const getCookieExpireDate = () => {
  const expires = new Date()
  expires.setHours(0, 0, 0, 0)
  expires.setDate(expires.getDate() + 365)
  return expires
}
const getOneYearExpireUTCString = () => getCookieExpireDate().toUTCString()
const assignData = data => _.assign({ isPooqzone: false }, data)
const assignIsPooqzone = data => _.assign({ isPooqzone: true }, data)
const setLoginUserInfoToCookie = userDataJson => {
  cookie.setItem('cs', JSON.stringify(userDataJson), null, constant.URL_COOKIE_DOMAIN, '/')
  store.commit('setCsInfo', cookie.getItem('cs'))
}
export const setUserDataAsync = data => {
  const profileId = _.get(data, 'profile', '0')
  const credential = _.get(data, 'credential', '')
  return getUserProfile(profileId, credential).then((response) => {
    const profileInfo = _.get(response, 'data', {})
    const { image, idx, alt, profilename } = profileInfo
    const adaptedProfile = _.assign({}, data, { profileimage: image, idx, alt, profilename })
    fp.flow(assignData, setLoginUserInfoToCookie)(adaptedProfile)
    return data
  })
}
const isSaveUserID = (saveId) => !_.isNil(saveId) && saveId
// const isAutoLogin = autoLogin => autoLogin !== '' &&
export const saveIdProcess = ({ saveId = false, userId }) => {
  if (isSaveUserID(saveId)) {
    cookie.setItem('userId', userId, getOneYearExpireUTCString(), constant.URL_COOKIE_DOMAIN, '/')
  } else {
    cookie.removeItem('userId', constant.URL_COOKIE_DOMAIN, '/')
  }
}
export const setAutoLoginInfo = ({ autoLogin, credential }) => {
  if (autoLogin) { cookie.setAutoLoginCredential(credential) }
}
const getCredential = data => _.get(data, 'credential', '')
const isAutoLoginUser = () => !cookie.isCsInfo() && cookie.getAutoLoginCredential() &&
  !(window.location.pathname.startsWith('/index') && !cookie.wasSetWavveOn())
const isVerifiedCredential = credential => !_.isNil(credential) && credential !== '' && credential !== 'none'
const ifLoginFailThenRedirect = response => {
  const { data, status } = response
  const { resultcode, resultmessage } = data
  if (status === 551 && resultcode === '301') {
    alertFromServer(resultmessage)
    window.location.href = 'member/login.html?referer=' + encodeURIComponent(location.href)
  }
}

const setSettings = () => {
  getAdultCertificationStatus().then(({ data }) => {
    setCookieAdultSetting('adult-settings', _.get(data, 'settings', 'N'))
  })
}
const deltetVerifiedAdult = () => {
  cookie.removeItem('verifiedAdult', constant.URL_COOKIE_DOMAIN, '/')
}
const routeToIndex = () => {
  window.location.href = '/index.html'
}

// Error의 두가지 케이스 1. 네트워크 에러 - catch가 잡는다. 2. 로그인상의 서버 에러 - 호출한 곳에서 처리
export const loginProc = async ({ userType, userId, userPassword, saveId, autoLogin, profile = '0' }) => {
  return postLogin({ type: userType, id: userId, pushid: 'none', password: userPassword, profile: profile }).then(({ data }) => {
    // const saltedHashResponse = await getSaltedHash(_.get(response, ['data', 'credential'], 'none'))
    // const saltedHash = _.get(saltedHashResponse, 'data', 'unknown')
    // AdbrixUtils.sendLoginLog(saltedHash)
    AdbrixUtils.sendLoginLog(_.get(data, 'uno', 'none'))
    return setUserDataAsync(data)
  }).then((data) => {
    saveIdProcess({ saveId, userId })
    setAutoLoginInfo({ autoLogin, credential: getCredential(data) })
    setUserID(userId)
    setSettings()
    deltetVerifiedAdult()
    AdbrixUtils.setUserProduct()
    return data
  })
}

const autoLoginFromCookieKeyAndDelete = (cookieKey) => {
  const credential = cookie.getItem(cookieKey)
  return postLogin({ type: 'credential', id: credential, pushid: '', password: '', profile: '' }).then(({ data }) => {
    AdbrixUtils.sendLoginLog(_.get(data, 'uno', 'none'))
    return setUserDataAsync(data)
  }).then(() => {
    cookie.removeItem(cookieKey, constant.URL_COOKIE_DOMAIN, '/')
  })
}

export const autoLoginSetting = (credential, isMultiLine = false) => {
  cookie.removeItem('verifiedAdult', constant.URL_COOKIE_DOMAIN, '/')
  if (isVerifiedCredential(credential)) {
    return postLogin({ type: 'credential', id: credential, pushid: '', password: '', profile: isMultiLine ? '0' : '' }).then((response) => {
      const { data } = response
      AdbrixUtils.sendLoginLog(_.get(data, 'uno', 'none'))
      ifLoginFailThenRedirect(response)
      return data
    }).then((data) => {
      return setUserDataAsync(data)
    })
  } else {
    return new Promise((resolve, reject) => {
      resolve(true)
    })
  }
}

const autoLoginProcess = () => {
  const credential = cookie.getAutoLoginCredential()
  return autoLoginSetting(credential).then((data) => {
    cookie.setAutoLoginCredential(getCredential(data))
    return data
  })
}

const COOKIE_KEY_SIGN_UP_CREDENTIAL = 'signup-credential'
const COOKIE_KEY_PASSWORD_CHANGE_CREDENTIAL = 'pwdChanged'
const COOKIE_KEY_MEMBER_LOG_OUT = 'member-logout'
const COOKIE_KEY_POOQ_ZONE_LOG_OUT = 'pooqzone-logout'
export const autoLoginProc = () => {
  if (isAutoLoginUser()) {
    return autoLoginProcess()
  } else if (cookie.hasItem(COOKIE_KEY_SIGN_UP_CREDENTIAL)) { // 회원가입 후
    return autoLoginFromCookieKeyAndDelete(COOKIE_KEY_SIGN_UP_CREDENTIAL)
  } else if (cookie.hasItem(COOKIE_KEY_PASSWORD_CHANGE_CREDENTIAL)) {
    return autoLoginFromCookieKeyAndDelete(COOKIE_KEY_PASSWORD_CHANGE_CREDENTIAL)
  } else if (cookie.hasItem(COOKIE_KEY_MEMBER_LOG_OUT)) {
    return logoutProc().then(() => {
      cookie.removeItem(COOKIE_KEY_MEMBER_LOG_OUT, constant.URL_COOKIE_DOMAIN, '/')
      routeToIndex()
    })
  } else if (cookie.hasItem(COOKIE_KEY_POOQ_ZONE_LOG_OUT)) {
    return logoutProc().then(() => {
      cookie.removeItems({ keyList: [ COOKIE_KEY_POOQ_ZONE_LOG_OUT, 'pzInfo', 'cs', 'pz' ] })
      cookie.setItem('pz', JSON.stringify({ isPooqzone: false }), false,
        constant.URL_COOKIE_DOMAIN, '/')
      routeToIndex()
    })
  }
}

export const changeProfileProc = ({ profileId }) => {
  const credential = cookie.getCredential()
  // 성인인증 정보 삭제
  cookie.removeItem('verifiedAdult', constant.URL_COOKIE_DOMAIN, '/')
  if (isVerifiedCredential(credential)) {
    return postLogin({ type: 'credential', id: credential, pushid: '', password: '', profile: profileId }).then(({ data }) => {
      return setUserDataAsync(data)
    }).then((data) => {
      if (cookie.getAutoLoginCredential()) {
        cookie.setAutoLoginCredential(getCredential(data))
      }
      const needSelectProfile = _.get(data, 'needselectprofile', 'n')
      if (needSelectProfile === 'y') {
        window.location.href = '/member/profile_list.html?referer=' + encodeURIComponent(location.href)
      }
      return data
    })
  }
}

export const pooqzoneLoginProc = ({ pincode }) => {
  const pooqZoneTempInfo = cookie.getPooqZoneTempInfo()
  const pooqZoneId = _.get(pooqZoneTempInfo, 'pooqzoneid', '')
  return postPooqzoneLogin({ pooqzoneid: pooqZoneId, pincode: pincode }).then(({ data }) => {
    cookie.removeItems({ keyList: ['pzInfo', 'pz', 'cs'] })
    cookie.setItem('cs', JSON.stringify(assignIsPooqzone(data)), null, constant.URL_COOKIE_DOMAIN, '/')
    cookie.setItem('pz', JSON.stringify(assignIsPooqzone(pooqZoneTempInfo)), false, constant.URL_COOKIE_DOMAIN, '/')
  })
}

export const logoutProc = () => {
  return postLogout({ pushid: '' }).then(() => {
    cookie.removeItems({ keyList: ['cs', 'credential', 'verifiedAdult', 'SHARE_KEY', 'adult-settings', 'adult-isOtt', 'targetage'] })
    sessionStorage.removeItem(SERVICE_LOCATION_KEY)
    Object.keys(localStorage).forEach((key) => {
      if (key !== 'guid') {
        localStorage.removeItem(key)
      }
    })
  })
}
